$(document).ready(function () {

    $('.tilt').each(function() {
        $('.tilt-container').mousemove(function(){
            $(this).addClass('moving');
            $('.tilt').css('z-index' , '1')

        });
        $('.tilt-container').mouseout(function(){
            $(this).removeClass('moving');
            $(this).removeClass('no-transition');
            $(this).css("transform", 'rotateY(0deg)\n\t\t\t\t\t\t\t\t   \t\trotateX(0deg)');
            $('.tilt').css('z-index' , '0');

        });
    });


});

